import angular from 'angular';

import ProductsActionsFactory from './products.actions.factory';
import MenuActionsFactory from './menu.actions.factory';

const actionsModule = angular.module('tinaba.common.actions', [])

.factory('ProductsActions', ProductsActionsFactory)

.factory('MenuActions', MenuActionsFactory);

export default actionsModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/actions/actions.js
 **/